import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getFFAirExportConsoleShipmentList, getFFAirExportHAWBStockList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import OverlayLoader from '../../../../../Common/Loaders/OverlayLoader';
import Tabbings from '../Tabs/Tabbings';
import AddAirExpHAWBStockOffcanvas from './AddAirExpHAWBStockOffcanvas';
import { getAirline } from '../../../../../Redux/action/Admin/EmployeeMasterAction';
import { getIATAAgentList, getMasterAirlineList } from '../../../../../Redux/action/MasterAction';
import EditAirExpHAWBStockOffcanvas from './EditAirExpHAWBStockOffcanvas';
import TabbingsAWBStock from '../Tabs/TabbingsAWBStock';


const ListFFAirExpHAWBStock = ({ ccessedModules, accessedPermission, title, ae_mawb_url, ae_hawb_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    const [hawbStock_id, setMawbStock_id] = useState(0);

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (hawb_stock_id) => {
        if (hawb_stock_id) {
            setMawbStock_id(hawb_stock_id);
            setShowEdit(true)
        } else {
            toast.error("Stock ID is not selected.")
        }
    }

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirExportHAWBStockList(token, user_id, queryParams.get("page") ?? 1));;
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);


    const refresh = () => {
        if (token && user_id) {
            dispatch(getFFAirExportHAWBStockList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }

    const {
        loadingFFAirExpHAWBStockList,
        FFAirExpHAWBStockList,
        FFAirExpHAWBStockListError,
        FFAirExpHAWBStockListCurrentPage,
        FFAirExpHAWBStockListTotalPage,
        FFAirExpHAWBStockListTotalData
    } = useSelector(state => state?.FFAirExpReducer);





    useEffect(() => {
        if (loadingFFAirExpHAWBStockList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFAirExpHAWBStockList]);

    // const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);



    useEffect(() => {
        if (FFAirExpHAWBStockList) {
            let arr = [];
            FFAirExpHAWBStockList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    hawb_no: val.final_hawb_stock_number,
                    stock_date: val.stock_date,
                    current_status: val.current_status,
                    created_by: val.created_by_name ?? "-",
                    created_at: val.created_at,
                    current_status: val.current_status,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                {
                                    // accessedPermission.includes("ff_ae_console_shipment_hawb_edit") && 
                                    <div className="dropdown-item" onClick={() => { handleShowEdit(val.id) }} >
                                        <i className="fas fa-edit text-blue-light me-1"></i> Edit
                                    </div>
                                }
                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        } else {
            setDataSource([]);
        }
    }, [FFAirExpHAWBStockList]);

    useEffect(() => {
        if (FFAirExpHAWBStockListCurrentPage) {
            setCurrentPage(FFAirExpHAWBStockListCurrentPage);
        }

        if (FFAirExpHAWBStockListTotalPage) {
            setTotalPages(FFAirExpHAWBStockListTotalPage)
        }
    }, [
        FFAirExpHAWBStockListCurrentPage,
        FFAirExpHAWBStockListTotalPage,
        FFAirExpHAWBStockListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "HAB No.", dataIndex: "hawb_no", key: "hawb_no" },
        { title: "Stock Date", dataIndex: "stock_date", key: "stock_date" },
        { title: "Created By", dataIndex: "created_by", key: "created_by" },
        { title: "Entered Date", dataIndex: "created_at", key: "created_at" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title} <span className="count-title">{FFAirExpHAWBStockListTotalData ? FFAirExpHAWBStockListTotalData : "0"}</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <TabbingsAWBStock
                                    ae_mawb_url={ae_mawb_url}
                                    ae_hawb_url={ae_hawb_url}
                                    tab_imp_exp={tab_imp_exp}
                                    tab_air_sea={tab_air_sea}
                                    accessedPermission={accessedPermission}
                                />
                                <div className="card">
                                    <div className="card-header">
                                        {
                                            // accessedPermission.includes("ff_ae_console_shipment_hawb_add") && 
                                            <div className="d-flex justify-content-end">
                                                <div className="btn btn-sm btn-primary" onClick={() => { handleShowAdd() }}>+Add HAWB Stock</div>
                                            </div>}
                                    </div>
                                    <div className="card-body">
                                        {/* Contact List */}
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer"
                                                // rowSelection={rowSelection} 
                                                dataSource={dataSource}
                                                columns={columns}
                                                pagination={false} />
                                        </div>

                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AddAirExpHAWBStockOffcanvas
                            show={showAdd}
                            handleClose={handleCloseAdd}
                            token={token}
                            user_id={user_id}
                            refresh={refresh}
                        />

                        <EditAirExpHAWBStockOffcanvas
                            hawbStock_id={hawbStock_id}
                            show={showEdit}
                            handleClose={handleCloseEdit}
                            token={token}
                            user_id={user_id}
                            refresh={refresh}
                        />
                    </>
            }
        </>

    )
}

export default ListFFAirExpHAWBStock;